// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { productCompareFlyOutStyles } from "@pace/Overrides/Components/ProductCompareFlyOut";
import IconX from "@pace/XDL/Icons/IconX";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 200,
    cssOverrides: {
        scrim: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 84px;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerBody: css`
            background: ${color("common.background")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 4px 8px;
                            height: 84px;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerTitle: css`
            background: ${color("common.background")};
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        padding: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                ],
                "max",
            )}
    `,
};

productCompareFlyOutStyles.productCarouselProductCondensed = {
    condensedActionsTemplateGridItem: {
        css: css`
            position: absolute;
            top: -6px;
            right: -2px;
            padding: 0;
        `,
    },
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    variant: "tertiary",
    sizeVariant: "small",
    css: css`
        padding: 0;
        & > ${IconWrapper} {
            color: ${color("secondary")};
            transition: all ${getProp("theme.transition.duration.regular", "300")}ms ease-in-out;
        }

        &&&:hover {
            & > ${IconWrapper} {
                color: ${color("common.ui9")};
            }
        }
        &:focus {
            background: none;
            border-color: transparent;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButtonIcon = {
    src: IconX,
    size: 16,
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h5",
    color: "text.main",
    css: css`
        margin: 0;
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    css: css`
        margin: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
    variant: "tertiary",
};
